import { render, staticRenderFns } from "./shipmentCharges.vue?vue&type=template&id=64893253&scoped=true"
import script from "./shipmentCharges.vue?vue&type=script&lang=js"
export * from "./shipmentCharges.vue?vue&type=script&lang=js"
import style0 from "./shipmentCharges.vue?vue&type=style&index=0&id=64893253&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64893253",
  null
  
)

export default component.exports